module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0026.jpg?v=006a4073";